<div
  class="mt-2"
  *ngFor="let attachment of attachments"
  (click)="downloadFile(attachment.id)"
  style="margin-bottom: 5px"
>
  <span style="cursor: pointer"><i class="fa fa-download"></i> {{ attachment.fileName }}</span>
</div>
